import React from 'react'
import Text from '../Text'
import Media from '../Media'

import * as styles from './testimonial.module.scss'
import classNames from 'classnames'

export default function Testimonial({
  quote,
  image,
  firstNameTitle,
  propertyType,
  location,
  light = false,
  odd,
}) {
  return (
    <div
      className={classNames('testimonial', styles.wrap, {
        [styles.withImage]: image,
        [styles.light]: light,
        [styles.odd]: odd,
      })}
    >
      {image && (
        <div className={styles.mediaWrap}>
          <Media desktop={image} />
        </div>
      )}

      <div className={styles.testimonial}>
        <div className={styles.quoteWrap}>
          <h2>"</h2>
          <Text subtitle={quote} subtitleAs="body2" />
        </div>

        <div className={styles.detailWrap}>
          <Text
            title={firstNameTitle}
            titleAs="body3"
            className={styles.firstNameTitle}
          />
          <Text
            subtitle={propertyType}
            subtitleAs="body3"
            className={styles.propertyType}
          />
          <Text
            subtitle={location}
            subtitleAs="body3"
            className={styles.location}
          />
        </div>
      </div>
    </div>
  )
}
